//记得在 src\components\lang\zhLoad.js 里面添加对象
const menu= {
  parentMenu:"父级菜单",
  menuNameZh: '中文菜单名称',
  menuNameEn:'英文菜单名称',
  menuNameNick:'菜单前端路径',
  menuModel:'菜单后端路径',
  hasChild:'是否有子项',
  displaySequence:'显示序列',
  menuDepth:"菜单层级",
  remark:'备注',
  addMenu:'菜单新增',
  editMenu:'菜单修改',
  assignButton:'按钮分配',
  opNo:'按钮编码',
  opName:'按钮名称',
  opType:"按钮类型",
  alias:'按钮别名',
  exportData:'导出数据',
  addButton:'添加自定义按钮',
  selectMenuButton:'勾选菜单按钮',
  menuInfo:'菜单信息',
  platform:'平台',
  no:'否',
  yes:'是',
  web:'web端',
  miniapp:'小程序端',
    msg:{
      menuNameZh:'请输入菜单名称',
      menuNameEn:"请输入英文名称",
      menuNameNick:'请输入菜单路径',
      menuModel:'请输入菜单后端路径',
      hasChild:'请选择是否有子项',
      displaySequence:'请输入显示序列',
      opNo:'请输入按钮编码',
      opName:'请输入按钮名称',
      alias:'请输入按钮别名',
      selectButtonMsg:'请勾选要添加的菜单按钮',
      deleteBtnMsg:'确认删除该按钮吗？',
      addMenuMsg:'叶子节点不能添加子菜单'
    }
};
export default menu



// WEBPACK FOOTER //
// ./src/page/auth/menu/lang/menu.zh.js